import { AnimatePresence, motion } from "framer-motion";
import { FaExclamationTriangle } from "react-icons/fa";
import "./Confirmdialog.css";

/**
 * ConfirmDialog — drop-in replacement for window.confirm().
 * Fully controlled: the parent owns `open` state and the async action.
 *
 * <ConfirmDialog
 *   open={!!pendingDelete}
 *   title="Delete this invoice?"
 *   message="This can't be undone."
 *   variant="danger"
 *   loading={deleting}
 *   onConfirm={handleConfirmDelete}
 *   onCancel={() => setPendingDelete(null)}
 * />
 */
function ConfirmDialog({
  open,
  title = "Are you sure?",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "default", // "default" | "danger"
  loading = false,
  onConfirm,
  onCancel,
}) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="app-confirm-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18 }}
          onClick={() => !loading && onCancel?.()}
        >
          <motion.div
            className={`app-confirm-dialog app-confirm-${variant}`}
            initial={{ opacity: 0, scale: 0.92, y: 14 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: 14 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            onClick={(e) => e.stopPropagation()}
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="app-confirm-title"
          >
            <div className="app-confirm-icon">
              <FaExclamationTriangle />
            </div>
            <h3 className="app-confirm-title" id="app-confirm-title">
              {title}
            </h3>
            {message && <p className="app-confirm-message">{message}</p>}
            <div className="app-confirm-actions">
              <button
                type="button"
                className="app-confirm-cancel"
                disabled={loading}
                onClick={onCancel}
              >
                {cancelLabel}
              </button>
              <button
                type="button"
                className={`app-confirm-confirm app-confirm-confirm-${variant}`}
                disabled={loading}
                onClick={onConfirm}
              >
                {loading ? "Please wait..." : confirmLabel}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ConfirmDialog;